module.exports = __webpack_public_path__ + "7a48759b1f67aca826e070e3a060571d.png";